"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

(function ($) {
  $.swipeshow = {};$.swipeshow.version = "0.10.8";var transitions = typeof $("<div>").css({ transition: "all" }).css("transition") == "string";var touchEnabled = "ontouchstart" in document.documentElement;var has3d = function () {
    var div = $("<div>");div.css("transform", "translate3d(0,0,0)");return div.css("transform") !== "";
  }();var instances = 0;function Swipeshow(element, options) {
    this.$slideshow = $(element);this.$container = this.$slideshow.find("> .slides");this.$slides = this.$container.find("> .slide");this.options = options;this.tag = ".swipeshow.swipeshow-" + ++instances;this.disabled = false;this.$next = getElement(this.$slideshow, options.$next, ".next", "~ .controls .next");this.$previous = getElement(this.$slideshow, options.$previous, ".previous", "~ .controls .previous");this.$dots = getElement(this.$slideshow, options.$dots, ".dots", "~ .controls .dots");this._addClasses();this._bindButtons();this._buildDots();if (options.keys) this._bindKeys();this.cycler = this._getCycler();if (options.autostart !== false) this._startSlideshow();this._bindSwipeEvents();this._bindHoverPausing();this._bindResize();return this;
  }Swipeshow.prototype = { goTo: function goTo(n) {
      this.cycler.goTo(n);return this;
    }, previous: function previous() {
      this.cycler.previous();return this;
    }, next: function next() {
      this.cycler.next();return this;
    }, pause: function pause() {
      this.cycler.pause();return this;
    }, start: function start() {
      this.cycler.start();return this;
    }, isStarted: function isStarted() {
      return this.cycler && this.cycler.isStarted();
    }, isPaused: function isPaused() {
      return !this.isStarted();
    }, defaults: { speed: 400, friction: .3, mouse: true, keys: true, swipeThreshold: { distance: 10, time: 400 } }, unbind: function unbind() {
      var $slideshow = this.$slideshow;var $container = this.$container;var $slides = this.$slides;var $dots = this.$dots;var tag = this.tag;this.cycler.pause();$container.find("img").off(tag);$container.off(tag);$(document).off(tag);$(window).off(tag);if ($dots.length) $dots.html("");$slideshow.data("swipeshow", null);$slideshow.removeClass("running paused swipeshow-active touch no-touch");$container.removeClass("gliding grabbed");$slides.removeClass("active");$dots.removeClass("active");$("html").removeClass("swipeshow-grabbed");
    }, _getCycler: function _getCycler() {
      var ss = this;var options = this.options;return new Cycler(ss.$slides, $.extend({}, options, { autostart: false, onactivate: $.proxy(this._onactivate, this), onpause: $.proxy(this._onpause, this), onstart: $.proxy(this._onstart, this) }));
    }, _onactivate: function _onactivate(current, i, prev, j) {
      if (this.options.onactivate) this.options.onactivate(current, i, prev, j);if (prev) $(prev).removeClass("active");if (current) $(current).addClass("active");if (this.$dots.length) {
        this.$dots.find(".dot-item.active").removeClass("active");this.$dots.find('.dot-item[data-index="' + i + '"]').addClass("active");
      }this._moveToSlide(i);
    }, _moveToSlide: function _moveToSlide(i) {
      var width = this.$slideshow.width();setOffset(this.$container, -1 * width * i, this.options.speed);
    }, _onpause: function _onpause() {
      if (this.options.onpause) this.options.onpause();this.$slideshow.addClass("paused").removeClass("running");
    }, _onstart: function _onstart() {
      if (this.options.onstart) this.options.onstart();this.$slideshow.removeClass("paused").addClass("running");
    }, _addClasses: function _addClasses() {
      this.$slideshow.addClass("paused swipeshow-active");this.$slideshow.addClass(touchEnabled ? "touch" : "no-touch");
    }, _buildDots: function _buildDots() {
      var ss = this;var $dots = ss.$dots;var tag = ss.tag;if (!$dots.length) return;$dots.html("").addClass("active");ss.$slides.each(function (i) {
        $dots.append($("<button class='dot-item' data-index='" + i + "'>" + "<span class='dot' data-number='" + (i + 1) + "'></span>" + "</button>"));
      });$dots.on("click" + tag, ".dot-item", function () {
        var index = +$(this).data("index");ss.goTo(index);
      });
    }, _bindKeys: function _bindKeys() {
      var ss = this;var tag = ss.tag;var RIGHT = 39,
          LEFT = 37;$(document).on("keyup" + tag, function (e) {
        if (e.keyCode == RIGHT) ss.next();else if (e.keyCode == LEFT) ss.previous();
      });
    }, _bindButtons: function _bindButtons() {
      var ss = this;this.$next.on("click", function (e) {
        e.preventDefault();if (!ss.disabled) ss.next();
      });this.$previous.on("click", function (e) {
        e.preventDefault();if (!ss.disabled) ss.previous();
      });
    }, _startSlideshow: function _startSlideshow() {
      var ss = this;var $images = ss.$slideshow.find("img");if ($images.length === 0) {
        ss.start();
      } else {
        ss.disabled = true;ss.$slideshow.addClass("disabled");$images.onloadall(function () {
          ss.disabled = false;ss.$slideshow.removeClass("disabled");ss.start();
        });
      }
    }, _bindResize: function _bindResize() {
      var ss = this;$(window).on("resize" + ss.tag, function () {
        var width = ss.$slideshow.width();setOffset(ss.$container, -1 * width * ss.cycler.current, 0);ss._reposition();
      });$(window).trigger("resize" + ss.tag);
    }, _reposition: function _reposition() {
      var width = this.$slideshow.width();var count = this.$slides.length;this.$slides.css({ width: width });this.$container.css({ width: width * count });this.$slides.css({ visibility: "visible" });this.$slides.each(function (i) {
        $(this).css({ left: width * i });
      });
    }, _bindHoverPausing: function _bindHoverPausing() {
      if (touchEnabled) return;var ss = this;var tag = ss.tag;var hoverPaused = false;ss.$slideshow.on("mouseenter" + tag, function () {
        if (!ss.isStarted()) return;hoverPaused = true;ss.pause();
      });ss.$slideshow.on("mouseleave" + tag, function () {
        if (!hoverPaused) return;hoverPaused = false;ss.start();
      });
    }, _bindSwipeEvents: function _bindSwipeEvents() {
      var ss = this;var $slideshow = ss.$slideshow;var $container = ss.$container;var c = ss.cycler;var options = ss.options;var tag = ss.tag;var moving = false;var origin;var start;var delta;var lastTouch;var minDelta;var width;var length = c.list.length;var friction = options.friction;$slideshow.data("swipeshow:tag", tag);$container.find("img").on("mousedown" + tag, function (e) {
        e.preventDefault();
      });$container.on("touchstart" + tag + (options.mouse ? " mousedown" + tag : ""), function (e) {
        if (isFlash(e)) return;if (e.type === "mousedown") e.preventDefault();if (ss.disabled) return;if ($container.is(":animated")) $container.stop();if ($(e.target).is("button, a, input, select, [data-tappable]")) {
          minDelta = 100;
        } else {
          minDelta = 0;
        }$container.addClass("grabbed");$("html").addClass("swipeshow-grabbed");width = $slideshow.width();moving = true;origin = { x: null };start = { x: getOffset($container), started: c.isStarted() };delta = 0;lastTouch = null;if (start.started) c.pause();
      });$(document).on("touchmove" + tag + (options.mouse ? " mousemove" + tag : ""), function (e) {
        if (ss.disabled) return;if ($container.is(":animated")) return;if (!moving) return;var x = getX(e);if (isNaN(x)) return;if (origin.x === null) origin.x = x;delta = x - origin.x;if (Math.abs(delta) <= minDelta) delta = 0;var target = start.x + delta;var max = -1 * width * (length - 1);if (Math.abs(delta) > 3) e.preventDefault();if (target > 0) target *= friction;if (target < max) target = max + (target - max) * friction;lastTouch = +new Date();setOffset($container, target, 0);
      });$(document).on("touchend" + tag + (options.mouse ? " mouseup" + tag : ""), function (e) {
        if (ss.disabled) return;if ($container.is(":animated")) return;if (!moving) return;if (isFlash(e)) return;var left = getOffset($container);$container.removeClass("grabbed");$("html").removeClass("swipeshow-grabbed");var index = -1 * Math.round(left / width);if (lastTouch && c.current === index) {
          var timeDelta = +new Date() - lastTouch;var threshold = options.swipeThreshold;if (Math.abs(delta) > threshold.distance && timeDelta < threshold.time) {
            var sign = delta < 0 ? -1 : 1;index -= sign;
          }
        }if (index < 0) index = 0;if (index > c.list.length - 1) index = c.list.length - 1;c.goTo(index);e.preventDefault();if (start.started) c.start();moving = false;
      });
    } };$.fn.swipeshow = function (options) {
    if (!options) options = {};options = $.extend({}, Swipeshow.prototype.defaults, options);$(this).each(function () {
      if ($(this).data("swipeshow")) return;var ss = new Swipeshow(this, options);$(this).data("swipeshow", ss);
    });return $(this).data("swipeshow");
  };$.fn.unswipeshow = function () {
    return this.each(function () {
      var ss = $(this).data("swipeshow");if (ss) ss.unbind();
    });
  };function getElement(root) {
    var arg;for (var i = 1; i < arguments.length; ++i) {
      arg = arguments[i];if (typeof arg === "string") {
        var $el = $(arg, root);if ($el.length) return $el;
      } else if ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) === "object" && arg.constructor === $ && arg.length) {
        return arg;
      }
    }return $();
  }var offsetTimer;function setOffset($el, left, speed) {
    $el.data("swipeshow:left", left);if (transitions) {
      if (speed === 0) {
        $el.css({ transform: translate(left, 0), transition: "none" });
      } else {
        $el.css({ transform: translate(left, 0), transition: "all " + speed + "ms ease" });
      }
    } else {
      if (speed === 0) {
        $el.css({ left: left });
      } else {
        $el.animate({ left: left }, speed);
      }
    }$el.addClass("gliding");if (typeof offsetTimer === "undefined") clearTimeout(offsetTimer);offsetTimer = setTimeout(function () {
      $el.removeClass("gliding");offsetTimer = undefined;
    }, speed);
  }function translate(x, y) {
    if (has3d) {
      return "translate3d(" + x + "px," + y + "px,0)";
    } else {
      return "translate(" + x + "px," + y + "px)";
    }
  }function getOffset($el) {
    return $el.data("swipeshow:left") || 0;
  }function getX(e) {
    if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0]) return e.originalEvent.touches[0].clientX;if (e.clientX) return e.clientX;
  }function isFlash(e) {
    return $(e.target).is("embed, object");
  }
})(jQuery);(function ($) {
  $.fn.onloadall = function (callback) {
    var $images = this;var images = { loaded: 0, total: $images.length };$images.on("load.onloadall", function () {
      if (++images.loaded >= images.total) {
        callback.apply($images);
      }
    });$(function () {
      $images.each(function () {
        if (this.complete) $(this).trigger("load.onloadall");
      });
    });return this;
  };
})(jQuery);(function () {
  function Cycler(list, options) {
    this.interval = options.interval || 3e3;this.onactivate = options.onactivate || function () {};this.onpause = options.onpause || function () {};this.onstart = options.onstart || function () {};this.initial = typeof options.initial === "undefined" ? 0 : options.initial;this.autostart = typeof options.autostart === "undefined" ? true : options.autostart;this.list = list;this.current = null;this.goTo(this.initial);if (this.autostart && typeof options.interval === "number") this.start();return this;
  }Cycler.prototype = { start: function start(silent) {
      var self = this;if (!self.isStarted() && !silent) self.onstart.apply(self);self.pause(true);self._timer = setTimeout(function () {
        self.next();
      }, self.interval);return self;
    }, pause: function pause(silent) {
      if (this.isStarted()) {
        if (!silent) this.onpause.apply(this);clearTimeout(this._timer);this._timer = null;
      }return this;
    }, restart: function restart(silent) {
      if (this.isStarted()) this.pause(true).start(silent);return this;
    }, previous: function previous() {
      return this.next(-1);
    }, isStarted: function isStarted() {
      return !!this._timer;
    }, isPaused: function isPaused() {
      return !this.isStarted();
    }, next: function next(i) {
      if (typeof i === "undefined") i = 1;var len = this.list.length;if (len === 0) return this;var idx = (this.current + i + len * 2) % len;return this.goTo(idx);
    }, goTo: function goTo(idx) {
      if (typeof idx !== "number") return this;var prev = this.current;this.current = idx;this.onactivate.call(this, this.list[idx], idx, this.list[prev], prev);this.restart(true);return this;
    } };window.Cycler = Cycler;
})();

//# sourceMappingURL=swipeshow-compiled.js.map


//////////////////
// WEBPACK FOOTER
// ./assets/js-lib/swipeshow-compiled.js
// module id = 954
// module chunks = 0